module.exports = __webpack_public_path__ + "static/media/workingmemory-words-4.5301474d.mp3";